import {GetRefundBanks} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundGetBanks} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundBanks = (): GetRefundBanks =>
	new RemoteRefundGetBanks(
		makeBFFApiUrl(RefundFlowEndPoints.banks),
		makeAuthorizeHttpClientDecorator(),
	);
